import React from 'react';
import { StyleSheet, Text, View, Image, Dimensions } from 'react-native';
const AllergiesHandler = props => {
    return (
        <div className="col-lg-12 ">
            <div className="card shadow-lg rounded" style={{ marginTop: 15, marginBottom: 10 }}>
                <div className='card-header text-white' style={props.styles}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Text style={{ fontWeight: '500', color: '#fff' }}>{props.algTitle}</Text>
                        <Text style={{ fontWeight: '500', color: '#fff' }}>{props.allergyLevel}</Text>
                    </View>
                </div>
                <div className="card-body">
                    <h4 className="card-title"><i className="mdi mdi-18px mdi-format-list-bulleted-type" /> <b>Type: </b>{props.algType}</h4>
                    <p className="card-text"><i className="mdi mdi-18px mdi-alert" /> <b>Reaction: </b>{props.symptoms}</p>
                    <p className="card-text"><i className="mdi mdi-18px mdi-comment-text" /> <b>Comments: </b>{props.comment}</p>
                </div>
            </div>
        </div>
    );
}

export default AllergiesHandler